// extracted by mini-css-extract-plugin
export default {"alert":"alers_alert__7ooO9","btnCloseAlet":"alers_btnCloseAlet__50kVZ","btnCloseAletIcon":"alers_btnCloseAletIcon__VFcxN"};